module.exports = __webpack_public_path__ + "img/block_user.7662ada8.png";